import { render, staticRenderFns } from "./ListItemShippingSizes.vue?vue&type=template&id=1d89cac6"
import script from "./ListItemShippingSizes.vue?vue&type=script&lang=js"
export * from "./ListItemShippingSizes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports